import { sceneLabel, translate } from '../i18n';
import type { HotspotConfig, Locale } from '../data/types';
import arrowIcon from '../assets/figma/icon-link-arrow.svg';
import tooltipArrow from '../assets/figma/tooltip-arrow.svg';
import styles from '../components/LinkHotspot.module.css';

interface LinkHotspotOptions {
  label: string;
  previewSrc?: string;
  onClick: () => void;
}

export function createLinkHotspotElement({
  label,
  previewSrc,
  onClick,
}: LinkHotspotOptions): HTMLElement {
  const el = document.createElement('button');
  el.type = 'button';
  el.className = styles.hotspot;
  el.setAttribute('aria-label', label);
  el.innerHTML = `
    <span class="${styles.content}">
      <span class="${styles.ring}">
        <span class="${styles.core}">
          <img class="${styles.arrow}" src="${arrowIcon}" width="24" height="24" alt="" />
        </span>
      </span>
      <span class="${styles.tooltipColumn}">
        <span class="${styles.tooltip}">
          <span class="${styles.tooltipArrow}">
            <img src="${tooltipArrow}" width="22.3493" height="20.1512" alt="" />
          </span>
          <span class="${styles.label}"></span>
        </span>
        ${
          previewSrc
            ? `<span class="${styles.preview}" aria-hidden="true">
          <img class="${styles.previewImg}" src="${previewSrc}" width="240" height="120" alt="" loading="lazy" decoding="async" />
        </span>`
            : ''
        }
      </span>
    </span>
  `;
  el.querySelector(`.${styles.label}`)!.textContent = label;

  el.addEventListener('click', (e) => {
    e.stopPropagation();
    onClick();
  });

  return el;
}

export function hotspotLabel(locale: Locale, hotspot: HotspotConfig): string {
  if (hotspot.labelKey) {
    const fromKey = translate(locale, hotspot.labelKey);
    if (fromKey !== hotspot.labelKey) return fromKey;
  }
  return sceneLabel(locale, hotspot.targetId);
}
